import { createSelector } from "reselect"
import { capitalize, find, get } from "lodash"
import { getContentSets } from "selectors/contentSets"
import { getSelectedFactorCategoryName } from "./data"

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate
const getPositionSetName = (_, props) => props.positionSetName
const getViewType = (_, props) => props.viewType
const getContentSetId = (_, props) => get(props, "params.contentSetId", get(props, "contentSetId"))

export const getScreenName = createSelector(
  [getContentSets, getContentSetId],
  (contentSets, contentSetId) => {
    if (contentSetId) {
      const contentSet = find(contentSets, ({ id }) => id === contentSetId)
      if (contentSet) {
        return `${contentSet.name} Exposure`
      }
    }
    return "Exposure"
  },
)

export const getFileName = createSelector(
  [getPositionSetName, getSelectedFactorCategoryName, getViewType, getScreenName, getStartDate, getEndDate],
  (positionSetName, categoryName, viewType, screenName, startDate, endDate) => `${positionSetName} ${categoryName} ${capitalize(viewType)} ${screenName} ${startDate} - ${endDate}`,
)
